import apiClient from './api-client';

const fechamentoService = {
    obter: async (ano, mes, profissionalId) => {
        try {
          const response = await apiClient.get('/fechamentos', {
            params: {
              ano: ano,
              mes: mes,
              profissionalId: profissionalId
            }
          });
          return response?.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      }
    }
    
    export default fechamentoService;